import { STATUS, useVerifyAction } from '@/providers/VerifyActionProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { ActionIcon, Box, Image, type MantineSize, Stack, Text, rem } from '@mantine/core';
import { IconCircleArrowDown } from '@tabler/icons-react';
export type KycCharacterProps = {
  visible?: (string & {}) | MantineSize | undefined;
  hidden?: (string & {}) | MantineSize | undefined;
};
export const KycCharacter: React.FC<KycCharacterProps> = ({
  visible,
  hidden
}) => {
  const {
    i18n
  } = useLingui();
  const {
    successes
  } = useVerifyAction();
  const characterLocked = '/assets/kyc/character-1.png';
  const characterUnlocked = '/assets/kyc/character_armor.png';
  return <Stack align="center" gap={8} visibleFrom={visible} hiddenFrom={hidden}>
      <Image src={successes.has(STATUS.ID_VERIFICATION) ? characterUnlocked : characterLocked} alt="character" w={{
      base: 314,
      sm: 230
    }} />

      {successes.has(STATUS.ID_VERIFICATION) ? <Text w={143} fz="sm" c="var(--text-dark)" className={gunterzBold.className} ta="center">
          {i18n._('VERIFICATION ')}
          <Text span inherit c="var(--text-green)">
            {i18n._('COMPLETE')}
          </Text>
        </Text> : <Stack gap={8} align="center">
          <Box>
            <Text fz="lg" className={gunterzBold.className} c="var(--text-prime)" ta="center">
              {i18n._('COMPLETE ALL STEPS')}
            </Text>
            <Text fz="lg" className={gunterzBold.className} c="var(--text-dark)" ta="center">
              {i18n._('TO UNLOCK ARMOR')}
            </Text>
          </Box>
          <Text fz="xs" c="var(--text-prime)" tt="uppercase">
            {i18n._('(1.3x multiplier)')}
          </Text>
          <ActionIcon variant="transparent">
            <IconCircleArrowDown size={50} color="var(--text-prime)" />
          </ActionIcon>
        </Stack>}
    </Stack>;
};